export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:4000',
  google: {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  },
} as const;
